// Who the problem behind an idea affects. Stored as the number, so the order (widest first) can be
// compared and sorted; ideas submitted before it was asked have none.
export const IDEA_REACHES = {
  WHOLE_COMPANY: 0,
  SEVERAL_TEAMS: 1,
  MY_TEAM: 2,
  ONLY_ME: 3,
} as const;

export type IdeaReach = (typeof IDEA_REACHES)[keyof typeof IDEA_REACHES];

export const IDEA_REACH_VALUES = Object.values(IDEA_REACHES) as IdeaReach[];

// The one place the numbers get their wording: the form, idea page, admin panel, edit history and CSV.
export const IDEA_REACH_LABELS: Record<IdeaReach, string> = {
  [IDEA_REACHES.WHOLE_COMPANY]: 'Whole company',
  [IDEA_REACHES.SEVERAL_TEAMS]: 'More than 1 team or department',
  [IDEA_REACHES.MY_TEAM]: 'My team',
  [IDEA_REACHES.ONLY_ME]: 'Only me',
};
